<template>
  <b-modal
    v-model="showModal"
    id="priorityModal"
    title="Update Rate Type"
    modal-class="priority-modal"
    centered
    hide-footer
    size="md"
  >
    <spinner-loader v-if="loading" />

    <b-form class="pricing-rate-form">
      <b-row>
        <b-col sm="12">
          <info-row class="info-main-row py-2" title="Rate Type" :sizing="3">
            <b-form-select
              v-model="form.priority"
              class="form-control"
              required
              :options="rateTypes"
              :state="fieldState.priority"
            />
          </info-row>
        </b-col>
      </b-row>
    </b-form>

    <b-row class="mx-0 mt-2">
      <b-col xs="6" class="px-2">
        <b-button class="my-2 w-100" variant="success" @click="saveRule">
          Save
        </b-button>
      </b-col>
      <b-col xs="6" class="px-2">
        <b-button class="my-2 w-100" variant="danger" @click="hide">
          Close
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import PricingMixin from '@/mixins/pricing-mixin';

export default {
  name: 'PriorityModal',

  components: {
    InfoRow: () => import('@/components/InfoRow'),
    SpinnerLoader: () => import('@/components/widgets/SpinnerLoader'),
  },

  mixins: [
    PricingMixin
  ],

  data() {
    return {
      form: {
        priority: ''
      },
      checkingForm: false,
      loading: false,
      showModal: false
    }
  },

  computed: {
    fieldState () {
      return {
        priority: this.checkingForm
          ? !!this.form.priority
          : null,
      }
    },
  },

  methods: {
    ...mapActions([
      'updateUnitPricingRule',
    ]),

    show(rule) {
      this.form = rule;
      this.showModal = true;
    },

    hide() {
      this.checkingForm = false;
      this.showModal = false;
    },

    saveRule() {
      this.checkingForm = true;

      if (this.fieldState.priority === false) {
        return;
      }

      let params = Object.assign({}, this.form);

      params.starts_at = new Date(Date.UTC(params.starts_at.getFullYear(), params.starts_at.getMonth(), params.starts_at.getDate()));
      params.ends_at = new Date(Date.UTC(params.ends_at.getFullYear(), params.ends_at.getMonth(), params.ends_at.getDate()));

      params.starts_at = params.starts_at
        .toISOString()
        .split('T')[0];

      params.ends_at = params.ends_at
        .toISOString()
        .split('T')[0];

      this.loading = true;

      this.updateUnitPricingRule(params)
        .then(res => {
          this.$emit('updated');
          this.hide();
        })
        .catch(err => {
          this.errorNotification(err.message || 'Failed to update priority');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.priority-modal {
  .modal-dialog {
    max-width: 380px;
  }

  .v-spinner {
    z-index: 999;
  }
}
</style>
